import { useState } from 'react';
import { useAxiosInstance } from '@gov-nx/api/axios';
import type { DokumentyDokumentDto } from '@gov-nx/api/generated/dokumenty.types';
import { usePoQuery } from '@gov-nx/api/hooks/usePoQuery';
import { documentsListQuery } from '@gov-nx/api/queries/documentQuery';
import { useExtraConfigContext } from '@gov-nx/core/app/extra-config/ExtraConfigProvider';
import { MyFilesSource } from '@gov-nx/module/page/moje-soubory/seznam/context.types';

export const useDocumentsModal = () => {
	const [showDocumentsModal, setShowDocumentsModal] = useState(false);
	const [documents, setDocuments] = useState<DokumentyDokumentDto[]>([]);
	const { axiosInstance } = useAxiosInstance();
	const {
		extraConfig: {
			pageRoutes: {
				databoxConfig: { isSelectAttachmentsFromOwnFilesRestrictedToPodani },
			},
		},
	} = useExtraConfigContext();

	usePoQuery({
		queryKey: ['documents-list'],
		queryFn: async () =>
			documentsListQuery(axiosInstance)({
				jeSoubor: true,
				smazano: false,
				razeni: '-datumVytvoreni',
				zdroje: isSelectAttachmentsFromOwnFilesRestrictedToPodani
					? MyFilesSource.VSTUP_NEBO_VYSTUP_PODANI
					: null,
			}),
		onSuccess: (data) => {
			setDocuments(data || []);
		},
	});

	return {
		showDocumentsModal,
		setShowDocumentsModal,
		documents: documents as DokumentyDokumentDto[],
		setDocuments,
	};
};
